// SEO tier 1 (T1-9 point 4): answer text for the FAQPage JSON-LD copy.
//
// On the page, a few FAQ answers end with a UI sentence that only makes sense
// next to a link: "... For complete terms click here " + a link labelled
// "Refund Policy" (ID: "... Untuk syarat lengkapnya klik disini " + "Ketentuan
// Pengembalian Dana"). Search engines read the JSON-LD as plain text, where it
// became "... click here Refund Policy". For the JSON-LD copy ONLY, drop that
// trailing call-to-action and the link label. The visible FAQ (layout/landing-v2
// /FAQ.js) keeps rendering item.answer + the link untouched.
const TRAILING_LINK_CTA = /\s*(?:for complete terms\s+click here|untuk syarat lengkapnya\s+klik disini)\s*$/i;

export const getFaqJsonLdAnswerText = (faq) => {
  const answer = `${(faq && faq.answer) || ""}`;
  if (!faq || !faq.answerLink) {
    return answer;
  }
  return answer.replace(TRAILING_LINK_CTA, "").trim();
};

export default getFaqJsonLdAnswerText;
